module.exports = __webpack_public_path__ + "images/my-own-ed74713f468ada0b5b339ed0972c2f73.jpg";